
import { defineComponent, ref, nextTick, computed, watch, getCurrentInstance } from "vue-demi";
import { SMNotifications, SMUser } from "@/store";

export default defineComponent({
  name: "AppNotification",

  setup() {
    const router = getCurrentInstance()?.proxy?.$router;

    const showAppNotification = ref(false);

    const lastUnreadNewsNotification = computed(() => SMNotifications.lastUnreadNewsNotification);

    watch(
      () => lastUnreadNewsNotification.value,
      (notification) => {
        if (!SMUser.isEmployer) return;

        if (SMNotifications.isLastUnreadNewsNotificationClosed) return;

        if (notification) {
          showAppNotification.value = !!notification?.object_id;
        }
      },
      { deep: true, immediate: true }
    );

    const wrap = ref<HTMLElement | null>(null);

    const onClose = () => {
      showAppNotification.value = false;

      SMNotifications.closeLastUnreadNewsNotification();
    };

    async function openNotification(id: number) {
      if (!id) return;

      try {
        await router.push(`${SMUser.basePath}/notifications/${id}`);
      } catch {
        return;
      } finally {
        onClose();
      }
    }

    const innerHeight = (wrapper: HTMLElement) => {
      const inner = wrapper.firstElementChild as HTMLElement; // .app-notification

      return inner.getBoundingClientRect().height;
    };

    // ENTER
    const beforeEnter = (el: Element) => {
      const e = el as HTMLElement; // .collapse-wrapper

      e.style.display = "block";
      e.style.overflow = "hidden";
      e.style.height = "0px";
    };

    const enter = async (el: Element) => {
      const e = el as HTMLElement;

      await nextTick();

      e.style.height = `${innerHeight(e)}px`;
    };

    const afterEnter = (el: Element) => {
      const e = el as HTMLElement;

      e.style.height = "";
      e.style.overflow = "";
      e.style.display = "";
    };

    // LEAVE
    const beforeLeave = (el: Element) => {
      const e = el as HTMLElement;

      e.style.display = "block";
      e.style.overflow = "hidden";
      e.style.height = `${e.getBoundingClientRect().height}px`;
    };

    const leave = (el: Element) => {
      const e = el as HTMLElement;
      void e.offsetHeight;
      e.style.height = "0px";
    };

    const afterLeave = (el: Element) => {
      const e = el as HTMLElement;
      e.style.height = "";
      e.style.overflow = "";
      e.style.display = "";
    };

    return {
      showAppNotification,
      lastUnreadNewsNotification,
      openNotification,
      onClose,
      wrap,
      beforeEnter,
      enter,
      afterEnter,
      beforeLeave,
      leave,
      afterLeave,
    };
  },
});
